<template>
<html style="overflow:scroll;height: 900px;">
<head>
  <link href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900">
  <link href="https://cdn.jsdelivr.net/npm/@mdi/font@6.x/css/materialdesignicons.min.css" rel="stylesheet" >
  <link href="https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css">
  <link href="https://cdnjs.cloudflare.com/ajax/libs/rangeslider.js/2.3.2/rangeslider.min.css"/>
  
  <!-- <link href="https://fonts.cdnfonts.com/css/whitney" rel="stylesheet" /> -->
  <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, minimal-ui">

</head>

<body style="padding-top: 0">
  
   <v-app >
    <v-main>
      <EmersonHeader v-if="$mq === 'lg'"/>

      <MobileEmersonHeader v-if="$mq === 'sm' || $mq === 'md'" /> 

      <v-container class="container" >

      <div v-if="$route.name != 'Disclaimer' && $mq === 'lg'">
          <h1 style="text-align:left;font-weight:300;margin-bottom:5px;" >Power Module Life Estimator</h1>
          <h2 style="text-align:left;font-weight:300;margin-bottom:15px;">The Power Module Life Estimator calculates estimated life of your wireless device's Emerson SmartPower™ Module based on update rate, network topology, and environmental conditions. Select a product, power module type and network topology to estimate power module life.</h2>
          
          <div  style="padding-right:0px!important;padding-left:0px!important;width:1180px!important;height:440px" class="grey lighten-3 py-3">
            <router-view />
            <p style="text-align:left;font-size:12px;margin-left:15px;font-weight:bold;margin-top:5px;">The contents of this estimator are presented for informational purposes only, and while effort has been made to ensure their accuracy, they are not to be construed as warranties or guarantees, express or implied.</p>
          </div>
          <div class="grey lighten-3 pt-3" style="width:1180px!important;">
            <div  class="result lighten-1 py-2" style ="display:flex;top:100%; right:0;left:0;height:60px;justify-content:right;padding-right: 15px;width:1180px!important;">     
              <v-btn v-if="isNotInConfig()" style="border-radius:0;font-weight:600;font-size:12px;" class="mr-4 reset reset-btn" width="200px" height="40px" @click="reset()">START OVER > </v-btn>             
              <v-btn v-if="isNotInConfig()" style="color:white;border-radius:0;font-weight:600;font-size:12px" class="bottom-btn" color="#00AA7E" width="200px" height="40px"  @click="viewProduct()">LEARN MORE  > </v-btn>
            </div>
          </div>
          
      </div>
      <div v-if="$route.name == 'Disclaimer'">
        <Disclaimer/>
      </div>


      <!--MOBILE VIEW--->
      <div style="width:90vw;padding-top:10px;justify-content: center;" class="grid-container" v-if="$route.name != 'Disclaimer' && $mq === 'sm' || $mq === 'md'">
        <div  class="item1" style="padding-left:4vw;padding-right:4vw">
          <h1 v-if="$mq === 'sm' || $mq === 'md'"  style="text-align:left;font-weight:300;font-size: 20px;" >Power Module Life Estimator</h1>
          <h2 v-if="$mq === 'sm' || $mq === 'md'"  style="text-align:left;font-weight:300;font-size: 10px;">The Power Module Life Estimator calculates estimated life of your wireless device's Emerson SmartPower™ Module based on update rate, architecture, and environmental inputs. Input a wireless device and key features to generate an estimated battery life and better plan power management.</h2>
        </div>

        <div class="item2" style="width:4vw;">
          
        </div>
        
       <div class="item3">
        <Mobile style="margin-top:10px;" />
        <p style="text-align:left;font-size:12px;margin-left:15px;font-weight:bold;margin-top:5px;">The contents of this estimator are presented for informational purposes only, and while effort has been made to ensure their accuracy, they are not to be construed as warranties or guarantees, express or implied.</p>
       </div>  
       <div class="item4"  style="width:4vw;">
        
       </div>
      </div>

      
    </v-container>  
    
  </v-main>
  <EmersonFooter v-if="$mq === 'lg'"/>
  <MobileEmersonFooter v-if="$mq === 'sm' || $mq === 'md'"  />
  </v-app>

  </body>
</html>
</template>

<script>
import Mobile from './views/Mobile'
import EmersonFooter from './components/EmersonFooter.vue'
import EmersonHeader from './components/EmersonHeader.vue'

import MobileEmersonHeader from './components/Mobile_EmersonHeader.vue'
import MobileEmersonFooter from './components/Mobile_EmersonFooter.vue'

import Disclaimer from './components/Disclaimer.vue'
export default {
  name: 'App',
  components:{Mobile,EmersonFooter,EmersonHeader,Disclaimer,MobileEmersonHeader,MobileEmersonFooter},
  methods: {
    isNotInConfig() {
      return this.$route.name === "Result";
     },
     reset(){
      this.$router.push('/')
      //this.$router.push('/')
    },
    viewProduct(){
      window.open(this.$store.state.view_product_result)
    },
    RouteToResult(){
      this.$router.push('/products/'+this.$store.state.selected_categoryID+'/instrument-type/'+this.$store.state.selected_instrumentTypeID+'/result/')
      this.$store.state.isApproximateEnabled = true
    }
  }
}
</script>

<style>
#app {
  font-family:'Noto Sans'!important;
  font-weight: 300;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.v-title{
  font-family:'Noto Sans'!important;
}
button{
  border-radius: 0;
}
@font-face {
    font-family: 'Noto Sans';
    src: url('./fonts/Noto_Sans/NotoSans-ExtraLight.ttf') format("truetype");
    
}
h1{
  font-family:'Noto Sans'!important;
  font-weight: 300!important;
}
h2{
  font-size: 16px;
}
.container{
  width: 1204px!important;
  padding-top: 0px!important;
  height: 100%;
}
.reset:hover .img_reset{
  margin-left: 15px;
}
.bottom-btn{
  border-radius:0;
  padding-top: 16px!important;
  padding-bottom: 16px!important;
}
.result{
  background-color:#C4CED1;
}
.cta-arrow{
  margin-left: 5px;
}
.bottom-btn:hover .cta-arrow{
 margin-left: 8px;
}
.bottom-btn:hover{
  background-color:#018a66!important;
}

.reset-btn:hover{
  background-color:#deecea!important;
}
.reset-btn:hover .cta-arrow{
 margin-left: 8px;
}
.grid-container {
  display: grid;
  grid-template-areas:
    'header header header header header header'
    'menu main main main main right'
}
.item1 { grid-area: header; }
.item2 { grid-area: menu; }
.item3 { grid-area: main; }
.item4 { grid-area: right; }
.item5 { grid-area: footer; }
</style>
